import PropTypes from "prop-types"

import { mapMetalClass } from "helpers/product/sku-colors"
import { cn } from "styles/utils"

const SkuSwatch = ({ className, sku, ...props }) => {
  const metalClass = mapMetalClass(sku)

  return (
    <div
      className={cn(
        "mx-px flex aspect-square size-full items-center justify-center rounded-full",
        metalClass,
        className
      )}
      {...props}
    />
  )
}

SkuSwatch.propTypes = {
  className: PropTypes.string,
  sku: PropTypes.string,
}

export default SkuSwatch
